import classNames from 'classnames';
import * as React from 'react';
import { useDeviceCondition } from '../../hooks';
import { AutoProlongContainer } from '../AutoProlong';
import * as styles from './Checkout.css';
import { SubagentNotEnoughMoneyModalContainer } from '../SubagentNotEnoughMoneyModal';
import { DetailContainer, TotalAmountContainer } from './components';
import { ICheckoutProps } from './types';
import { CommercialDiscountContainer } from './components/CommercialDiscount';

export const Checkout = (props: ICheckoutProps) => {
  const { details, isAutoProlongVisible } = props;

  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={classNames(rootStyle, styles['wrapper'])}>
      {!!details.length && (
        <div className={styles['details']}>
          {details.map((_, index) => (
            <DetailContainer index={index} key={index} />
          ))}
          <CommercialDiscountContainer />
        </div>
      )}

      {isAutoProlongVisible && (
        <div className={styles['autoprolong']}>
          <AutoProlongContainer />
        </div>
      )}

      <div className={styles['total']}>
        <TotalAmountContainer />
      </div>

      <SubagentNotEnoughMoneyModalContainer />
    </div>
  );
};
